import React from "react";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { fichiersService } from "../../services";
import { showToast, Loading } from "../../components";
import CustomDataTable from "../DataTable";
import { columnsFileds } from "./filesColumns";
import { useQueryClient } from "@tanstack/react-query";
import { Tooltip } from "react-tooltip";
import { ModalPreview } from "./preview";
import  ModalEditFichier  from "./ModalEditFichier";



export const DataTableGexBox = ({
  fichiers,
  setSelectedFiles,
  selectedFiles,
  openModal,
  setSelectedFichier,
  isGexpertise,
  isNotViewer,
  setLoading,
}) => {
  const queryClient = useQueryClient();

    const [previewVisible, setPreviewVisible] = React.useState(false);
    const [previewUrl, setPreviewUrl] = React.useState("");
  
    const [editVisible, setEditVisible] = React.useState(false);
    const [fileToEdit, setFileToEdit] = React.useState(null);

    const handlePreview = (url: string) => {
      setPreviewUrl(url);
      setPreviewVisible(true);
    };

    const handleEdit = (file) => {
    setFileToEdit(file);
    setEditVisible(true);
  };


  const TraitmentFichier = async (id) => {
    try {
      setLoading(true);

      await fichiersService.encoursFichier(id, id);
      setLoading(false);

      showToast("info", "Fichier en cours d'analyse");
      queryClient.refetchQueries({
        queryKey: ["fichiers"],
      });
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  const FinishedTraitment = async (id) => {
    try {
      setLoading(true);

      await fichiersService.validationFichier(id, id);
      setLoading(false);

      showToast("success", "Fichier validé et actif en attente");
      queryClient.refetchQueries({
        queryKey: ["fichiers"],
      });
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  const InitialiseFiciher = async (id) => {
    try {
      setLoading(true);

      await fichiersService.atraiterFichier(id, id);
      setLoading(false);

      showToast("info", "Fichier revenir à l'état initial");
      queryClient.refetchQueries({
        queryKey: ["fichiers"],
      });
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex ">
        {(isGexpertise() || isNotViewer()) && (
          <>
            {rowData?.status_fichier?.split(".").pop() == "ACTIF_EN_ATTENTE" ? (
              <Button
                data-tooltip-id="status-file"
                data-tooltip-content="Changer le statut"
                onClick={() => InitialiseFiciher(rowData.id)}
                icon="pi pi-minus-circle"
                rounded
                text
                severity="info"
                aria-label="Bookmark"
              />
            ) : (
              <>
                {rowData?.status_fichier?.split(".").pop() == "A_TRAITER" ? (
                  <Button
                    data-tooltip-id="status-file"
                    data-tooltip-content="Changer le statut"
                    onClick={() => TraitmentFichier(rowData.id)}
                    icon="pi pi-play"
                    rounded
                    text
                    severity="warning"
                    aria-label="Bookmark"
                  />
                ) : (
                  <>
                    <Button
                      data-tooltip-id="status-file"
                      data-tooltip-content="Changer le statut"
                      onClick={() => FinishedTraitment(rowData.id)}
                      icon="pi pi-check-circle"
                      rounded
                      text
                      severity="success"
                      aria-label="Bookmark"
                    />
                    <Button
                      data-tooltip-id="status-file"
                      data-tooltip-content="Changer le statut"
                      onClick={() => InitialiseFiciher(rowData.id)}
                      icon="pi pi-minus-circle"
                      rounded
                      text
                      severity="info"
                      aria-label="Bookmark"
                    />
                    
                   
                  </>
                )}
                  
              </>
            )}
     
            
      
            <Button
              data-tooltip-id="delete-file"
              icon="pi pi-trash"
              rounded
              text
              severity="danger"
              aria-label="Bookmark"
              onClick={() => {
                openModal("delete");
                setSelectedFichier(rowData);
              }}
            />
            <Tooltip id="delete-file" place="top" >    
            Supprimer le fichier
          </Tooltip>
          </>
        )}

        <Button
          data-tooltip-id="download-file"
          onClick={() => window.open(rowData?.url_ressources, "_blank")}
          icon="pi pi-download"
          rounded
          text
          severity="secondary"
          aria-label="Bookmark"
        />
         <Tooltip id="download-file" place="top" >    
            Télécharger le fichier
          </Tooltip>
          <Tooltip id="status-file" place="top" />

            <Button
              icon="pi pi-eye"
              rounded
              text
              severity="info"
              onClick={() => handlePreview(rowData.url_ressources)}
            />
            <Button
              icon="pi pi-pencil"
              rounded
              text
              severity="warning"
              onClick={() => handleEdit(rowData)}

              />

            
            <ModalPreview visible={previewVisible} setVisible={setPreviewVisible} fileUrl={previewUrl} />
             <ModalEditFichier
                modalIsOpen={editVisible}
                closeModal={() => setEditVisible(false)}
                selectedFichier={fileToEdit}
                setLoading={setLoading}
              />
      </div>

      
    );
  };


const ValiderFichiersGroupe = async () => {
  try {
    setLoading(true);
    const status = selectedFiles[0]?.status_fichier?.split(".").pop();

    // On mappe le statut commun vers la bonne transition
    const actionParStatus = {
      A_TRAITER: fichiersService.encoursFichier,
      // à adapter si tu veux sauter directement A_TRAITER -> ACTIF_EN_ATTENTE
      // sinon on peut chaîner : encours puis validation
    };

    await Promise.all(
      selectedFiles.map((f) => fichiersService.validationFichier(f.id, f.id))
    );

    setLoading(false);
    showToast("success", "Fichiers validés avec succès");
    queryClient.refetchQueries({ queryKey: ["fichiers"] });
    setSelectedFiles([]);
  } catch (e) {
    setLoading(false);
    console.log("Error while fetching", e);
    showToast("danger", "Erreur lors de la validation groupée");
  }
};


  const sameStatusSelection =
  selectedFiles.length > 1 &&
  selectedFiles.every(
    (f) =>
      f.status_fichier?.split(".").pop() ===
      selectedFiles[0].status_fichier?.split(".").pop()
  );

  const header = (
    <div className="flex justify-between">
      <span className="text-xl text-900 font-bold ">Liste des fichiers</span>
      <div className="flex space-x-2">
        
             {selectedFiles.length !== 0 && isNotViewer() ? (
        <div className="flex space-x-2">
          {sameStatusSelection && (
            <Button
              label="Valider"
              icon="pi pi-check"
              rounded
              className="bg-gexpertise-300"
              raised
              onClick={ValiderFichiersGroupe}
            />
          )} 
            <Button
              label="Correspondance"
              icon="pi pi-link"
              rounded
              className=" bg-gexpertise-200"
              raised
              disabled={
                !selectedFiles.every(
                  (file) =>
                    file.status_fichier?.split(".").pop() === "ACTIF_EN_ATTENTE"
                )
              }
              onClick={() => openModal("correspondance")}
            />
            <Button
              label="Supprimer"
              icon="pi pi-trash"
              rounded
              className=" bg-gexpertise-100"
              raised
              onClick={() => openModal("deletemany")}
            />
          </div>
        ) : null}
      </div>
    </div>
  );

  const columns = columnsFileds.map((column: any, index) => {
    return (
      <Column
        key={index}
        field={column.field}
        header={column.header}
        body={column.body}
        style={column.style}
        editor={column.editor}
        sortable={column.sortable}
        filter={column.filter}
      />
    );
  });
  return (
    <>
      <CustomDataTable
        data={fichiers}
        header={header}
        emptyMessage="Pas de fichier disponible dans le gexbox."
        selectedRows={selectedFiles}
        onSelectionChange={(e) => setSelectedFiles(e.value)}
        children={columns}
        actionColumn={(rowData) => actionBodyTemplate(rowData)}
        showCheckbox={true}
        isNotViewer={isNotViewer}
      />
    </>
  );
};

export const DataTableFiles = ({ fichiers, isNotViewer }) => {
  const queryClient = useQueryClient();
  const [previewVisible, setPreviewVisible] = React.useState(false);
  const [previewUrl, setPreviewUrl] = React.useState("");

  const handlePreview = (url: string) => {
      setPreviewUrl(url);
      setPreviewVisible(true);
    };

  const handleDesassocierFichier = async (rowData) => {
    try {
      await fichiersService.DesassocierFichier({ file_id: [rowData.id]});
      queryClient.refetchQueries({ queryKey: ["classeurs"] });
      showToast("success", "Fichier désassocié avec succès !");
    } catch (error) {
      console.error("Erreur lors de la désassociation du fichier", error);
      showToast("error", "Impossible de désassocier le fichier.");
    }
  };



  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button
          onClick={() => window.open(rowData?.url_ressources, "_blank")}
          icon="pi pi-download"
          rounded
          text
          severity="secondary"
          aria-label="Bookmark"
        />
        {isNotViewer() && (
          <Button
            icon="pi pi-trash"
            rounded
            text
            severity="danger"
            aria-label="Supprimer"
            onClick={() => handleDesassocierFichier(rowData)}
          />
        )}

         <Button
              icon="pi pi-eye"
              rounded
              text
              severity="info"
              onClick={() => handlePreview(rowData.url_ressources)}
            />

            
            <ModalPreview visible={previewVisible} setVisible={setPreviewVisible} fileUrl={previewUrl} />
      </div>
    );
  };

  const columns = columnsFileds.map((column: any, index) => {
    return (
      <Column
        key={index}
        field={column.field}
        header={column.header}
        body={column.body}
        style={column.style}
        editor={column.editor}
        sortable={column.sortable}
        filter={column.filter}
      />
    );
  });

  return (
  
    <CustomDataTable
      data={fichiers}
      emptyMessage="Pas de fichier disponible pour ce classeur"
      children={columns}
      actionColumn={(rowData) => actionBodyTemplate(rowData)}
      showCheckbox={false}
      isNotViewer={isNotViewer}
    />
   
  );
};
